/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};


/**js**/

var BRAEKPOINT_SP = 768;
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

// UA
var TouchDevice = 0;
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf("ipad") > -1 || ua.indexOf("macintosh") > -1 && "ontouchend" in document) {
  $('html,body').addClass('ua-touch');
  TouchDevice = 1;
}
var loader = new ProgressBar.Line(loader__image, {
  easing: 'easeInOut',
  duration: 1000,
  strokeWidth: 0.2,
  color: '#DC4505',
  trailWidth: 0.2,
  trailColor: '#eee'
});
window.addEventListener("load", function () {
  var JsLoader = document.getElementById('js__loader');
  var body = document.querySelector('body');
  var mainContainer = document.querySelector('.site__main__contents');
  var docH = mainContainer.offsetHeight;
  var backLayer = document.getElementById('js-backlayer');
  backLayer.style.height = docH + 'px';
  mainContainer.style.overflow = '';
  loader.animate(1.0, function () {
    $("#js__loader").delay(500).fadeOut(800);
    JsLoader.classList.add('js-fadeOut');
    body.classList.remove('over-hidden');
    body.classList.add('complete');
    // setTimeout(function(){
    //   JsLoader.classList.add('js-fadeOut');
    //   body.classList.remove('over-hidden');
    //   body.classList.add('complete');
    // }, 1500);
  });

  var tl = gsap.timeline();
  var jsHeader = document.getElementById('js-header');
  tl.to(jsHeader, {
    y: 0,
    opacity: 1
  }, 2.4);
});

// resize
var resizeTimer;
var interval = 1000;
window.addEventListener('resize', function () {
  if (resizeTimer !== false) {
    if ($(window).width() >= BRAEKPOINT_SP && TouchDevice < 1) {
      window.location.reload();
    } else {
      clearTimeout(resizeTimer);
    }
  }
  resizeTimer = setTimeout(function () {
    var mainContainer = document.querySelector('.site__main__contents');
    var docH = mainContainer.offsetHeight;
    var backLayer = document.getElementById('js-backlayer');
    backLayer.style.height = docH + 'px';
    mainContainer.style.overflow = '';
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    locoScroll.update();
  }, interval);
});
setTimeout(function () {
  locoScroll.destroy();
}, 0);
setTimeout(function () {
  locoScroll.init();
}, 100);
setTimeout(function () {
  locoScroll.update();
}, 300);

// locomotiveScroll
var locoScroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true,
  lerp: 0.1,
  multiplier: 1.2,
  reloadOnContextChange: true,
  touchMultiplier: 2,
  smoothMobile: 0,
  smartphone: {
    smooth: 0,
    breakpoint: 767
  },
  mobile: {
    smooth: false,
    breakpoint: 0,
    getDirection: true
  },
  tablet: {
    smooth: false,
    breakpoint: 0,
    getDirection: true
  }
});
locoScroll.on('scroll', ScrollTrigger.update);
ScrollTrigger.scrollerProxy('.site__main__contents', {
  scrollTop: function scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
  },
  getBoundingClientRect: function getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  pinType: document.querySelector('.site__main__contents').style.transform ? "transform" : "fixed"
});
ScrollTrigger.addEventListener('refresh', function () {
  return locoScroll.update();
});
ScrollTrigger.refresh();
gsap.registerPlugin(ScrollTrigger);
if ($(window).width() >= BRAEKPOINT_SP && TouchDevice < 1) {
  // hero
  var heroImgs = document.querySelectorAll('.hero-viewer__canvas');
  var frame_count = 60;
  var getOffsetPosition = function getOffsetPosition() {
    var offset_value = 1000;
    var OffsetPos = -offset_value * (frame_count - 1) + 'px 50%';
    return OffsetPos;
  };
  gsap.to(heroImgs, {
    backgroundPosition: function backgroundPosition() {
      return "".concat(getOffsetPosition());
    },
    ease: 'steps(' + frame_count + ')',
    scrollTrigger: {
      trigger: '#hero-viewer-js',
      start: "top top",
      end: '+=' + frame_count * 50,
      scrub: true,
      scroller: '.site__main__contents'
    }
  });

  // backlayer
  var backlayerImgs = document.querySelectorAll('.js-backlayer__img');
  backlayerImgs.forEach(function (backlayerImg, index) {
    gsap.to(backlayerImg, {
      scrollTrigger: {
        trigger: backlayerImg,
        start: 'top bottom-=300',
        end: 'top top',
        once: true,
        scroller: '.site__main__contents',
        onEnter: function onEnter() {
          return backlayerImg.classList.add("js-fadeImg");
        }
      }
    });
  });
}

// mylife (interview)
var jsInterviewImgs = document.querySelectorAll('.fade-up-ttl');
jsInterviewImgs.forEach(function (jsInterviewImg, index) {
  gsap.to(jsInterviewImg, {
    scrollTrigger: {
      trigger: jsInterviewImg,
      start: 'top bottom',
      end: 'top top',
      once: true,
      scroller: '.site__main__contents',
      onEnter: function onEnter() {
        return jsInterviewImg.classList.add("js-fadeUp-ttl");
      }
    }
  });
});

// details
var detailsElem = document.querySelector("details");
detailsElem.addEventListener("toggle", function (evt) {
  if (detailsElem.open) {
    locoScroll.update();
  } else {
    locoScroll.update();
  }
}, false);

// pagetop
var pagetopBtn = document.getElementById('pagetop');
ScrollTrigger.create({
  trigger: '.site__main__contents',
  start: 'top -50%',
  end: 'bottom+=100% bottom',
  scroller: '.site__main__contents',
  toggleClass: {
    targets: pagetopBtn,
    className: 'js-active'
  }
});
$(function () {
  // jquery.magnific-popup
  $('.thanks__photolist').magnificPopup({
    delegate: 'a',
    type: 'image',
    removalDelay: 400,
    gallery: {
      enabled: true
    }
  });

  // video control
  var videoplayer = $('#videoDigest').get(0);
  $('#pausevideo').on('click', function () {
    videoplayer.pause();
    $(this).addClass('is-hidden');
    $('#playvideo').removeClass('is-hidden');
  });
  $('#playvideo').on('click', function () {
    videoplayer.play();
    $(this).addClass('is-hidden');
    $('#pausevideo').removeClass('is-hidden');
  });
  $('#mutevideo').on("click", function () {
    if (videoplayer.muted) {
      videoplayer.muted = false;
      $('#mutevideo').removeClass('-mute');
      $('#mutevideo').addClass('-unmute');
    } else {
      videoplayer.muted = true;
      $('#mutevideo').removeClass('-unmute');
      $('#mutevideo').addClass('-mute');
    }
  });
  $("#seekvideo").on('click', function () {
    videoplayer.currentTime = 0;
  });

  // products slider
  $('.slider__inner').each(function () {
    var sliderWidth = $(this).width();
    $(this).clone(true).insertBefore(this);
    $(this).clone(true).insertAfter(this);
    $('.slider').css('width', sliderWidth * 3);
  });
});
/******/ })()
;
//# sourceMappingURL=bundle_add.js.map